import TextInput from '@oncolens/oncolens-ui/lib/components/FormControls/TextInput';
import useDebounce from '@oncolens/oncolens-ui/lib/hooks/common/useDebounce';
import clsx from 'clsx';
import React, { useState } from 'react';
import { BsSearch } from 'react-icons/bs';

interface Props {
  setQuery: (value: string) => void;
  testSelector: string;
  className?: string;
}

const TableSearch = ({ testSelector, setQuery, className }: Props) => {
  const [inputValue, setInputValue] = useState('');
  const debouncedSearch = useDebounce((value: string) => setQuery(value), 500);

  return (
    <div className={clsx('relative w-1/3', className)}>
      <BsSearch className="absolute left-2.5 top-2.5 text-gray-700 z-10" />
      <TextInput
        placeholder="Search"
        label="search"
        srLabel={true}
        inputProps={{ className: 'pl-8' }}
        type="text"
        id="table-search"
        htmlName="table-search"
        value={inputValue}
        testSelector={testSelector}
        onChange={(event: any) => {
          const value = event.target.value as string;

          setInputValue(value);
          debouncedSearch(value);
        }}
      />
    </div>
  );
};

export { TableSearch as default };
